import { VERSION, REVISION } from "../consts/version";
import { return_user_name } from "../firebase/functions";

jQuery(document).ready(function ($) {
  $(".bottom-banner").css("display", "none");

  $(".lazy").Lazy({
    scrollDirection: "vertical",
    effect: "fadeIn",
    visibleOnly: true,
    onError: function (element) {
      return;
    },
  });

  if (JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
    $(".not-logged-in-profile").css("display", "none");

    let user_image_url;
    let user_email;
    let user_info;

    if (localStorage.getItem("user_info")) {
      if (JSON.parse(localStorage.getItem("user_info"))?.photoURL) {
        user_image_url = JSON.parse(localStorage.getItem("user_info")).photoURL;
      } else {
        if (JSON.parse(localStorage.getItem("user_info"))?.imageURL) {
          user_image_url = JSON.parse(
            localStorage.getItem("user_info")
          ).imageURL;
        }
      }

      user_email = JSON.parse(localStorage.getItem("user"))?.email;

      user_info = JSON.parse(localStorage.getItem("user_info"));
    }

    if (localStorage.getItem("user")) {
      if (JSON.parse(localStorage.getItem("user"))) {
        if (JSON.parse(localStorage.getItem("user"))?.photoURL) {
          if (JSON.parse(localStorage.getItem("user"))?.photoURL !== "") {
            user_image_url = JSON.parse(localStorage.getItem("user"))?.photoURL;
          }
        }
      }
    }

    if (user_info) {
      $("#update-first-name").val(user_info.firstName);
      $("#update-last-name").val(user_info.lastName);
      $("#update-user-name").val(user_info.username);
      $("#update-age").val(user_info.age);
      $("#update-first-name").val(user_info.firstName);
      $("#update-country").val(user_info.country);
      $("#update-about-me").val(user_info.about);
      for (let i = 0; i < $("input[name=update-gender]").length; i++) {
        if ($("input[name=update-gender]")[i].value == user_info.gender) {
          $("input[name=update-gender]")[i].checked = "true";
        }
      }
    }

    if (user_image_url) {
      var user_name = return_user_name();
      $(".user-profile-image").attr("src", user_image_url);

      $(".header-profile-props").html(
        `<a data-gtm-event="profile_clicked" data-gtm-category="top_menu" data-gtm-label="${user_name}" href="/profile" class="logged-in-profile"><img class="loggedin-user-profile-image" id="loggedin-user-profile-image"
                   src=${user_image_url} alt=""></a>`
      );
      $(".uploaded-user-img").attr("src", user_image_url).css("opacity", "1");

      $(".upload-img").css("opacity", "0");
    } else {
      $(".user-profile-image").attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/temp/profile-img.png"
      );
      $(".header-profile-props").html(
        `  <a data-gtm-event="profile_clicked" data-gtm-category="top_menu" data-gtm-label="${user_name}"   href="/profile" class="logged-in-profile"><img class="loggedin-user-profile-image" id="loggedin-user-profile-image" src="/wp-content/themes/atyabtabkha/src/assets/images/temp/profile-img.png" alt="" ></a>`
      );
    }

    if (
      JSON.parse(localStorage.getItem("user")).providerData[0].providerId ==
      "facebook.com"
    ) {
      $(".user-name").text(
        JSON.parse(localStorage.getItem("user")).providerData[0].displayName
      );
    } else {
      if (user_info && user_info.username) {
        $(".user-name").text(user_info.username);
      } else {
        $(".user-name").text(user_email);
      }
    }

    if (JSON.parse(localStorage.getItem("user_info"))?.showFaved) {
      $("#show_my_favorite_recipes").prop("checked", true);
    } else {
      $("#show_my_favorite_recipes").prop("checked", false);
    }
  }

  $(".popup--secondary .js-link").click(function () {
    $(".popup--secondary").removeClass("is-active");
  });

  $(".js-link--secondary#verify-success-close").on("click", function () {
    $("#verify-success").removeClass("is-active");
    $("#verify-success").attr("class", "popup popup--secondary");
    document.getElementById("verify-success").classList.remove("is-active");
  });

  $(window).on("load", function () {
    //Version set start
    $("#version-number").html(`v${VERSION} (${REVISION})`);
    //Version set end

    //slider add start
    $(".slider").css("display", "block");
    //slider add end

    //show/hide add start
    setTimeout(() => {
      if ($("#gpt-ad-btf-lb > div")) {
        $(".bottom-banner").css("display", "block");
      } else {
        $(".bottom-banner").css("display", "none");
      }
    }, 1000);
    //show/hide add end
  });

  $(window).on("resize", function () {
    const wrapper = document.getElementById("page-wrapper");
    if ($(window).width() > 767) {
      $("#popup-menu").removeClass("is-active");
      $("#header-burger-menu").css("visibility", "visible").css("opacity", 1);
      $("#popup-menu-close").css("visibility", "hidden").css("opacity", 0);
    }

    if (!$("#popup-menu").hasClass("is-active")) {
      $("html").css("overflowY", "visible");
    }

    if ($(window).width() >= 2952) {
      wrapper.classList.add("wrapper-zoom-out-support");
      $(".section-primary ").attr("style", "max-width: 127.6rem");
    } else {
      wrapper.classList.remove("wrapper-zoom-out-support");
      $(".section-primary ").attr("style", "max-width: unset");
    }
  });

  if ($("#breadcrumbs_container")) {
    if ($("#breadcrumbs_container")[0]) {
      if ($("#breadcrumbs_container")[0].childElementCount == 0) {
        $("#breadcrumbs_container").css("display", "none");
      }
    }
  }

  if (localStorage.getItem("user_info")) {
    if (JSON.parse(localStorage.getItem("user_info"))?.cookbooks) {
      if (
        JSON.parse(localStorage.getItem("user_info"))?.cookbooks.length !== 0
      ) {
        if (JSON.parse(localStorage.getItem("user_info"))?.cookbooks) {
          $("#my_cookbooks_count").css("display", "block");
          $("#my_cookbooks_count").text(
            JSON.parse(localStorage.getItem("user_info"))?.cookbooks.length
          );
        }
      }
    }
  } else {
    $("#my_cookbooks_count").css("display", "none");
    $("#my_cookbooks_count").text("0");
  }

  if (window.location.pathname.includes("/recipe/")) {
    if ($("#youtube__iframe")) {
      $(".btn-play").addClass("is-not-visible");
      $(".article").addClass("play-video");
      $(".galery").addClass("play-video");
      $(".story").addClass("play-video");
    }
  }
});
